import { cn } from '@/lib/utils';

/** Airtable's own mark (public/logos), for the surfaces that connect to it or
 * show what was exported to it. */
export function AirtableIcon({ className }: { className?: string }) {
  return (
    <img
      src='/logos/airtable.svg'
      alt=''
      aria-hidden
      className={cn('shrink-0 object-contain', className)}
    />
  );
}
